import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { CHECKBOX_SIZES, CHECKBOX_DIMENSIONS } from './Checkbox.constants.js';

var _templateObject, _templateObject2, _templateObject3;
var CheckboxContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  width: fit-content;\n  opacity: ", ";\n\n  input[type='checkbox'] {\n    position: absolute;\n    appearance: none;\n  }\n\n  &:hover {\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.small;
}, function (_ref2) {
  var theme = _ref2.theme,
    $disabled = _ref2.$disabled;
  return $disabled && theme.opacity.disabled;
}, function (_ref3) {
  var theme = _ref3.theme,
    $checked = _ref3.$checked,
    $disabled = _ref3.$disabled;
  return !$disabled && "\n      span {\n      ".concat($checked ? "background-color: ".concat(theme.colours["interface"].strong, ";") : "border: ".concat(theme.sizing.xtiny, " solid ").concat(theme.colours.layering[0].strong, ";"), "\n    }\n  ");
});
var StyledLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  color: ", ";\n  ", "\n  ", "\n"])), function (_ref4) {
  var $disabled = _ref4.$disabled;
  return !$disabled && 'pointer';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colours.ink.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme,
    $size = _ref6.$size;
  return theme.typography[$size === CHECKBOX_SIZES.REGULAR ? 'bodyRegular' : 'bodyMedium'];
}, function (_ref7) {
  var $withLabel = _ref7.$withLabel;
  return !$withLabel && "display: none;";
});
var PseudoCheckbox = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: grid;\n  place-items: center;\n  cursor: ", ";\n  border: ", " solid\n    ", ";\n  border-radius: ", ";\n  height: ", ";\n  width: ", ";\n  color: ", ";\n  background-color: ", ";\n\n  &:focus-visible {\n    box-shadow: ", ";\n    outline: none;\n  }\n\n  svg {\n    fill: ", ";\n  }\n"])), function (_ref8) {
  var $disabled = _ref8.$disabled;
  return !$disabled && 'pointer';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.xtiny;
}, function (_ref10) {
  var theme = _ref10.theme,
    $checked = _ref10.$checked;
  return $checked ? 'transparent' : theme.colours.layering[0].main;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadius.tertiary;
}, function (_ref12) {
  var $size = _ref12.$size;
  return CHECKBOX_DIMENSIONS[$size];
}, function (_ref13) {
  var $size = _ref13.$size;
  return CHECKBOX_DIMENSIONS[$size];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colours["interface"].ink;
}, function (_ref15) {
  var theme = _ref15.theme,
    $checked = _ref15.$checked,
    $disabled = _ref15.$disabled;
  switch (true) {
    case $checked:
      return theme.colours["interface"].main;
    case !$checked && $disabled:
      return theme.colours.layering[0].main;
    default:
      return 'transparent';
  }
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.effects.focus;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colours.graphics.inverse.main;
});

export { CheckboxContainer, PseudoCheckbox, StyledLabel };
//# sourceMappingURL=Checkbox.styles.js.map
